(function () {
  if (innerWidth > 749) return;
  function start() {
    var tr = document.querySelector('.n1-pdp__titlerow'), pb = document.querySelector('[data-n1-pricebox]');
    if (tr && pb) tr.appendChild(pb);
    var t = document.querySelector('[id$="__rail_perf"] [data-n1-items]');
    if (t) t.scrollLeft = 0;
    var m = document.querySelector('[data-n1m-move]');
    if (m) { var to = document.querySelector('[id$="__' + m.getAttribute('data-n1m-move') + '"]'); if (to) to.appendChild(m); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
